<template>
  <footer class="hide-768">
    <div>
      <span class="font-tiny font-gray-two">© 2021 Union poisťovňa, a. s.</span>
    </div>
    <div>
      <a href="https://www.union.sk/union-o-poistovni" target="_blank" class="font-tiny font-gray-two mr-1">
        Informácie o poisťovateľovi
      </a>
      <a href='https://www.union.sk/wp-content/uploads/2021/03/Zakladne-informacie-o-ochrane-osobnych-udajov_potencialni-klienti-klienti-alebo-osoba-opravnena-na-prijatie-poistneho-plnenia-1.pdf'
         target="_blank" class="font-tiny font-gray-two">
        Ochrana osobných údajov
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>
